import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'di-bouton-panneau',
  templateUrl: './bouton-panneau.component.html',
  styleUrls: ['./bouton-panneau.component.scss'],
})
export class BoutonPanneauComponent implements OnInit, OnChanges {

  @ViewChild('menuDetailPatient', { static: false }) menuDetailPatient!:
    ElementRef<HTMLDivElement>;

  @Input()
  public iconName?: string;

  @Input()
  public content?: string;

  @Input()
  public placeHolder = "";

  @Input()
  public dotted = false;

  @Input()
  public large = false;

  @Input()
  public hasContent = false;

  @Input() typeAction?: string;

  @Input() clickAction!: (element: HTMLDivElement, typeActon: string) => void;

  constructor(
    private el: ElementRef
  ) { }

  ngOnInit() {
    this.setBoutonColor();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.content) {
      this.setBoutonColor();
    }
  }

  public openMenu() {
    if (this.menuDetailPatient && this.clickAction && this.typeAction)
      this.clickAction(this.menuDetailPatient.nativeElement, this.typeAction);
  }

  public setBoutonColor() {
    if (!this.content) {
      this.el.nativeElement.style.setProperty('--my-color', `var(--Noir80)`);
    } else {
      this.el.nativeElement.style.setProperty('--my-color', `var(--CouleurPrimaire)`);
    }
  }
}
